export default "__VITE_ASSET__e7bef7d2__"